<template>
  <div id="aside" ref="aside">
    <div
      @click="toTop"
      class="to_top animate__animated animate__flipInY"
      v-show="toTopShow"
    >
      Top
    </div>
    <div
      class="aside_box animate__animated animate__slideInRight"
      v-show="asideBtnShow"
      @mouseleave="hidePopover"
    >
      <div @mouseenter="showPopover(1)">微信</div>
      <div @mouseenter="showPopover(2)">电话</div>
      <div @mouseenter="showPopover(3)">公众号</div>
      <div @click="asideBtnShow = false">
        <i
          class="el-icon-d-arrow-right"
          style="font-size: 24px; margin-top: 18px"
        ></i>
      </div>
      <section
        @mouseleave="hidePopover"
        ref="popover"
        v-show="showPopover"
        class="popover"
      >
        <img v-if="showIndex == 1" src="../assets/img/companyWx.png" alt="" />
        <span v-if="showIndex == 2">19603903563</span>
        <img v-if="showIndex == 3" src="../assets/img/companyWx.png" alt="" />
      </section>
    </div>
    <section
      class="aside_btn animate__animated animate__slideInRight"
      @click="asideBtnShow = true"
      v-show="!asideBtnShow"
    >
      <i class="el-icon-d-arrow-left"></i>
    </section>
  </div>
</template>

<script>
export default {
  props: {},
  name: "Aside",
  data() {
    return {
      toTopShow: false,
      showIndex: 1,
      asideBtnShow: false,
      asideConfig: [
        // title : 标题，  imgUrl : 图片地址，content : 内容信息
        //  imgUrl和content 取其中一个
        { id: 1, title: "微信", imgUrl: "", content: "" },
        { id: 2, title: "电话", imgUrl: "", content: "" },
        { id: 3, title: "公众号", imgUrl: "", content: "" },
      ],
    };
  },
  created() {},
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    // 初始化设置 html 字体大小
    this.setHtmlFontSize();
    // 窗口大小变化时重新计算
    window.addEventListener("resize", this.setHtmlFontSize);
  },
  methods: {
    setHtmlFontSize() {
      const screenWidth = window.screen.width;
      let top = 40;
      // 根据分辨率自动调整
      if (screenWidth <= 1440) {
        top = 30;
      } else {
        top = 40;
      }

      // 赋值给 html 根标签
      this.$refs.aside.style.top = top + "%";
    },
    showPopover(index) {
      this.showIndex = index;
      this.$refs.popover.style.display = "block";
    },
    hidePopover() {
      this.$refs.popover.style.display = "none";
    },
    toTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    handleScroll() {
      // 获取当前滚动距离
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 500) {
        this.toTopShow = true;
      } else {
        this.toTopShow = false;
      }
    },
  },
};
</script>

<style scoped lang="less">
#aside {
  width: 6.25rem;
  position: fixed;
  right: 0;
  top: 40%;
  padding: 0.625rem 1.25rem 0;
  box-sizing: border-box;
  border-radius: 10px 0 0 10px;
  z-index: 999;

  > div {
    width: 100%;
    backdrop-filter: blur(30px);
    background: hsla(0, 0%, 100%, 0.6);
    border: 1px solid hsla(210, 5%, 54%, 0.16);
    box-shadow: 0 6px 16px 0 rgba(50, 73, 198, 0.02),
      0 8px 48px 0 rgba(50, 73, 198, 0.12);
    opacity: 1;
    box-sizing: border-box;
  }
  > div:hover {
    cursor: pointer;
  }
  .to_top {
    font-size: 0.875rem;
    border-radius: 50px;
    height: 3.75rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .aside_box {
    border-radius: 50px;
    position: relative;
    margin: 10px 0;
    padding: 0.625rem 0;
    > div {
      height: 3.125rem;
      line-height: 50px;
      border-bottom: 1px solid #eee;
      font-size: 0.875rem;
    }
    > div:last-of-type {
      border-bottom: none;
    }
  }
}
.popover {
  padding: 1.25rem;
  border-radius: 10px;
  position: absolute;
  white-space: nowrap;
  background: #fff;
  box-shadow: 0 6px 16px 0 rgba(50, 73, 198, 0.02),
    0 8px 48px 0 rgba(50, 73, 198, 0.12);
  top: 0;
  right: 110%;
  display: none;
  > img {
    width: 120px;
  }
}

.aside_btn {
  font-size: 1.875rem;
  height: 3.75rem;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  border-radius: 50%;
}
</style>
